/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Step_1_BodyInputs */

const da_forside_step_1_body = /** @type {(inputs: Forside_Step_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload rettevejledning og omsætningstabel. Appen læser tabellen, og du kan rette den.`)
};

/** @type {(inputs: Forside_Step_1_BodyInputs) => LocalizedString} */
const en_forside_step_1_body = da_forside_step_1_body;

/**

* @param {Forside_Step_1_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_step_1_body = /** @type {((inputs?: Forside_Step_1_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Step_1_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_step_1_body(inputs)
	return /** @type {LocalizedString} */ ("Upload rettevejledning og omsætningstabel. Appen læser tabellen, og du kan rette den.")
});